module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Gatsby Starter Landing Page","short_name":"Gatsby Starter Landing Page","start_url":"/","background_color":"#fff","theme_color":"#000","display":"browser","icon":"src/assets/gatsby-monogram.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"955a9d05c5c141a98f792a6172f6a651"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
